import { Component } from "react";

import EventBrowserTable from "./eventbrowser/Browser.Event.Browser.Table.Component";
import EventByKeyBrowserTable from "./eventbrowser/Browser.Event.By.Key.Browser.Table.Component";

class EventBrowserComponent extends Component {
  render() {
    return (
      <div>
        <h3>Event browser</h3>
        <EventBrowserTable {...this.props} />
        <hr />
        <EventByKeyBrowserTable {...this.props} />
      </div>
    );
  }
}
export default EventBrowserComponent;
